module.exports = __webpack_public_path__ + "img/gaku_btn_06.a17d0d88.png";